import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  admin,
  announce,
  announcement,
  apptime,
  arrow,
  daily_result,
  friends,
  help,
  history,
  link,
  links,
  logout,
  notification,
  notificationP,
  overall,
  recharge,
  report,
  rightArrow,
  side_bar,
  wallet,
  winning,
  withdraw,
} from "../../assets/img";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { APP_VERSION, ICON_FILTER, URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
import CustomScroll from "../../Component/CustomScroll";
import {MaskIcon} from "../MaskIcon";

const Profile = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;
    const savedPosition = sessionStorage.getItem("profileScrollPosition");

    // // console.log("fromFooter:", fromFooter, "savedPosition:", savedPosition);

    if (scrollRef.current) {
      if (fromFooter) {
        scrollRef.current.scrollTop = 0;
        navigate(location.pathname, { state: { fromFooter: false } });
      } else if (savedPosition) {
        // Delay to ensure DOM is fully rendered
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop = Number(savedPosition);
          }
          sessionStorage.setItem("profileScrollPosition", 0);
        }, 0);
      }
    }
  }, [location]);

  useEffect(() => {
    const content = scrollRef.current;
    if (content) {
      content.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (content) {
        content.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const handleScroll = () => {
    const position = scrollRef.current ? scrollRef.current.scrollTop : 0;
    sessionStorage.setItem("profileScrollPosition", position);
  };

  const menuRef = useRef(null);
  const profiledata = [
    {
      icon: friends,
      title: "REFER FRIENDS",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/refer-friends",
    },
    {
      icon: wallet,
      title: "WALLET",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/wallet",
    },
    {
      icon: wallet,
      title: "WITHDRAW",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/withdraw",
    },
    {
      icon: recharge,
      title: "RECHARGE",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/recharge",
    },
    {
      icon: overall,
      title: "RECHARGE HISTORY",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/recharge-history",
    },
    {
      icon: daily_result,
      title: "DAILY RESULT",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/daily-result",
    },
    {
      icon: report,
      title: "MY REPORT",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/my-report",
    },
    {
      icon: notificationP,
      title: "NOTIFICATIONS",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/notifications",
    },
    {
      icon: winning,
      title: "WINNING HISTORY",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/winning-history",
    },
    {
      icon: links,
      title: "LINKS",
      arrow: ArrowForwardIosOutlinedIcon,
      path: "/links",
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      setLoading(true);
      const res = await post(URLS.LOGOUT);
      // // console.log("res logout", res);
      if (res.status === "success") {
        Toast(res.message || "Logout Successfully!");
        setTimeout(() => {
          sessionStorage.clear();
          localStorage.removeItem("token");
          setLoading(false);
          setPopup(false);
          navigate("/", { replace: true });
        }, 1000);
      }
    } catch (err) {
      // // console.log('err logout', err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashRightView-foots px-0 pt-0">
      <CustomScroll ref={scrollRef}>
        <div className="container-fluid  container_overalls">
          <div className="profile-list">
            {profiledata.map((item, index) => (
              <div
                className="d-flex ac-jb profile-item"
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate(item.path);
                }}
              >
                <div className="d-flex ac-js gap-3">
                  <MaskIcon src={item.icon} height={19} width={18} alt="icon" />
                  <p
                    style={{ color: "#8F0D3d" }}
                    className="f3 dashboard_title1 fs-xs-16 fs-sm-18 fs-md-18 fs-lg-20 mb-0"
                  >
                    {item.title}
                  </p>
                </div>
                <MaskIcon src={rightArrow} height={15} alt="icon" />
              </div>
            ))}
          </div>
        </div>
        <div
          className="d-flex ac-jc my-3  gap-1 pointer"
          onClick={() => setPopup(true)}
        >
          <MaskIcon src={logout} height={16} width={18} />
          <p
            style={{ color: "black" }}
            className="f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 logout_text primary"
          >
            LOGOUT
          </p>
        </div>
        <div
          style={{ marginBottom: 30 }}
          className="d-flex ac-jc download-border gap-1 pointer"
          onClick={() => {
            const link = document.createElement("a");
            link.href = process.env.PUBLIC_URL + "/Kandha.apk";
            link.setAttribute("download", "Kandha.apk");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
        >
          <p
            style={{ color: "#8F0D3d" }}
            className="f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
          >
            <FileDownloadOutlinedIcon style={{ color: "#8F0D3d" }} /> Download
            App Now
          </p>
        </div>

        <div
          className="d-flex ac-jc   gap-1 pointer"
          style={{ marginBottom: 50 }}
        >
          <p
            style={{ color: "black" }}
            className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 logout_text "
          >
            Version : {APP_VERSION}
          </p>
        </div>

        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure, you want to logout?
              </p>
              <div
                style={{ gap: 10 }}
                className="d-flex ac-jb  pt-4 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                <button
                  onClick={() => setPopup(false)}
                  style={{ width: " 100%", height: 42 }}
                  className="no-btn"
                >
                  No
                </button>
                <button
                  style={{ width: " 100%", height: 42,color:'white' }}
                  onClick={handleLogout}
                  className="yes-btn f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    "Yes"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};

export default Profile;
